export default __webpack_public_path__ + "static/media/enroll-ellipse.061adba2.png";